import React from 'react';
import ProductCard from './ProductCard';
import {
  Egg,
  Popcorn,
  Beef,
  Salad,
  Wheat,
  Drumstick,
  Flame,
  CakeSlice,
  Coffee,
  GlassWater,
  Sparkles
} from 'lucide-react';

const iconMap = {
  egg: Egg,
  popcorn: Popcorn,
  beef: Beef,
  salad: Salad,
  wheat: Wheat,
  drumstick: Drumstick,
  flame: Flame,
  cakeSlice: CakeSlice,
  coffee: Coffee,
  glassWater: GlassWater,
  sparkles: Sparkles
};

const CategorySection = ({ category, isActive }) => {
  const IconComponent = iconMap[category.icon] || Sparkles;

  return (
    <section
      id={`category-${category.id}`}
      className={`scroll-mt-40 transition-opacity duration-500 ${isActive ? 'opacity-100' : 'opacity-70'}`}
    >
      {/* Category Header */}
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center">
          <IconComponent className="w-5 h-5 text-amber-400" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-white">{category.name}</h2>
          <p className="text-neutral-400 text-sm">{category.products.length} ürün</p>
        </div>
      </div>

      {/* Products Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {category.products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
};

export default CategorySection;